var _defs, _path, _path2, _path3, _path4, _line, _line2, _line3, _line4, _path5, _path6, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaptopCrashed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e1ecff;}.cls-2{fill:#ff97c9;}.cls-3{fill:#1c3177;}.cls-4{fill:#f774b9;}.cls-5{fill:none;stroke:#99adf9;stroke-linecap:round;stroke-miterlimit:10;stroke-width:18px;}.cls-6{fill:#fec272;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.89,766C26.29,718.9,74,592.89,145.94,515.83c87.48-93.69,208.08-172.5,441.19-145.7,192.49,22.14,312,119.22,352.65,169.23,64.64,79.48,111.34,191.62,72.41,238-65.33,77.85-335.25-54.61-481.66-57.31S170.48,871,70.89,766Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M762.61,690.75H254.51L147.64,341.38A22.29,22.29,0,0,1,169,312.56H630.42a22.3,22.3,0,0,1,21.33,15.78Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M679.4,649.16H314.88a22.52,22.52,0,0,1-21.53-15.92L212.42,368.66a11.22,11.22,0,0,1,10.74-14.51H587.68a22.52,22.52,0,0,1,21.53,15.92l80.93,264.58A11.22,11.22,0,0,1,679.4,649.16Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M254.51,690.75H937a17.36,17.36,0,0,1,17.36,17.36V731.3A17.36,17.36,0,0,1,937,748.66H271.87a17.36,17.36,0,0,1-17.36-17.36V690.75A0,0,0,0,1,254.51,690.75Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 337.69,
    y1: 514.4,
    x2: 379.2,
    y2: 468.07
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 389,
    y1: 514.4,
    x2: 326.49,
    y2: 468.07
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 542.67,
    y1: 514.4,
    x2: 584.18,
    y2: 468.07
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 593.98,
    y1: 514.4,
    x2: 531.46,
    y2: 468.07
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M440.07,543.68s32.54-17.94,65.59,0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M795.44,489A16.51,16.51,0,0,1,779.35,476c-3.06-13.79-5-24.32-2.3-34.17,3.24-11.68,11.79-18.52,21-25.06,6.21-4.4,10.52-11.08,11-17,.3-3.93-1.08-7.24-4.35-10.4-9.66-9.37-25.3,5.21-26,5.84,0,0-13.14,11.12-22.9-.54s0-23.22,0-23.22a75.89,75.89,0,0,1,21.42-14c18.79-8,36.69-5,50.41,8.25,10.26,9.94,15.33,22.95,14.28,36.63-1.21,15.78-10.48,31.27-24.81,41.41-6.73,4.77-8,6.46-8.31,7-.77,2.44,1.77,13.87,2.73,18.18A16.53,16.53,0,0,1,795.44,489Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 803.39,
    cy: 527.09,
    r: 19.13
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopCrashed);
export default __webpack_public_path__ + "static/media/LaptopCrashed.12e76ec005dd82ec59c90d5799869e39.svg";
export { ForwardRef as ReactComponent };